import React, { FC } from 'react';
import { useMutipleItemsSlider } from '../../../hooks/useMutipleItemsSlider';
import { ProductImage } from '../../ProductImage';
import { usePromotionPaginationQuery } from '../ApiRequests';
import styles from './Promotions.module.css';
import { Promotion } from './Types';

const PromotionSlider: FC<{
    promotions: Promotion[],
    promotionsPerSlider: number
}> = ({ promotions, promotionsPerSlider }) => {
    const promotionSlider = useMutipleItemsSlider<Promotion>(promotions, promotionsPerSlider);

    return (
        <div className={styles.productBasicSlider}>
            <div className={styles.prev} onClick={promotionSlider.previousSlide}>❮</div>
            {
                promotionSlider.currentPromotions.map((promotion) => {
                    return (
                        <a href={`/Product/${promotion.id}`} key={promotion.id}>
                            <ProductImage desc={promotion.desc} imageSrc={promotion.imageSrc}
                                title={promotion.title} />
                        </a>
                    )
                })
            }
            <div className={styles.next} onClick={promotionSlider.nextSlide}>❯</div>
        </div>
    );
}

export const Promotions = () => {
    const promotionsQuery = usePromotionPaginationQuery();

    if (promotionsQuery.isLoading) {
        return <span>Loading...</span>
    }

    if (promotionsQuery.isError) {
        return <span>Error: {promotionsQuery.error.message}</span>
    }

    return (
        <section className={styles.promotions}>
            <PromotionSlider promotions={promotionsQuery.data} promotionsPerSlider={4} />
        </section>
    );
}
